module.exports = __webpack_public_path__ + "img/3c.dcdd2fbd.svg";